// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-1XuSxHYm clearfix","box":"box-3D_v68pE"};